import { Box } from "@mui/material";
import React from "react";
import styled from "styled-components";
import footerLogo from "../media/logo/footerLogo.png";

const FooterContainer = styled.footer.attrs(({ height }) => ({
  style: {
    height,
  },
}))`
  width: 100vw;
  color: #0b2149;
  display: flex;
  // flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  position: relative;
  z-index: 100000;
  background: white;
`;

const InnerContent = styled(Box)`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Logo = styled.img`
  width: 100%;
  max-width: 280px;
  height: auto;
  object-fit: contain;
`;

const Description = styled.p`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  font-weight: 400;
  font-family: "Outfit", sans-serif;
  // max-width: 500px;
  color: #192b61;
`;

const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  font-size: 12px;

  a {
    margin: 0 10px;
    text-decoration: none;
    color: #0b2149;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const Copyright = styled.div`
  font-size: 12px;
  color: #4b667a;
  margin-top: 20px;
`;

const footerDimensions = { height: "25vh" };

const DesktopFooter = ({ footerPosition, pageWidthCalc }) => {
  console.log("insideFooter", footerPosition, pageWidthCalc);
  return (
    <FooterContainer height={footerDimensions.height}>
      <InnerContent
        style={{
          left: `${footerPosition}px`,
          width: `${pageWidthCalc}px`,
        }}
      >
        <Box
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            marginBottom: "24px",
            justifyContent: "center",
          }}
        >
          <Box
            style={{
              width: "50%",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Logo src={footerLogo} alt="footer logo" />
          </Box>
          <Box
            style={{
              width: "50%",
            }}
          >
            <Description>
              Empowering brands with immersive 3D solutions that transform how
              products are showcased, enhancing engagement and driving growth
              effortlessly.
            </Description>
          </Box>
        </Box>

        <Box
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <Box
            style={{
              width: "50%",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <Box
              style={{
                fontSize: "14px",
                color: "#192B61",
                fontFamily: "Outfit",
                fontWeight: "500",
                letterSpacing: "0.1px",
                height: "20px",
              }}
            >
              ©2025 Xculptor 3DTech Pvt Limited
            </Box>
          </Box>
          <FooterBottom style={{ width: "50%" }}>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "center",
                fontSize: "14px",
                color: "#192B61",
                fontFamily: "Outfit",
                fontWeight: "500",
                letterSpacing: "0.1px",
                height: "20px",
              }}
            >
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/terms-and-conditions">Terms & Conditions</a>
            </Box>
          </FooterBottom>
        </Box>
      </InnerContent>
    </FooterContainer>
  );
};

export default DesktopFooter;
